import React, { Component } from 'react'
import { connect } from 'react-redux'

import Divider from 'material-ui/Divider'
import TextField from 'material-ui/TextField'

import Select from 'components/Select'
import PropertyCombobox from '../PropertyCombobox'
import Comments from 'components/Comments'
import DueDatePicker from '../DueDatePicker'
import Lines from '../Lines'
import TransactionMemo from '../TransactionMemo'
import CheckBoxIsPaid from '../CheckBoxIsPaid'
import PaymentMethodSelect from '../PaymentMethodSelect'
import Attachments from 'components/Attachments'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import { vendors } from 'selectors/entities'

var tmpAcct = ""
var tmpAddr = ""
var tmpPhn = ""
var memoEd = false

let select = dirtyRead(
	(state, props) => ({
		transaction: doc(state, props.transactionID)
	  , vendors: vendors(state)
	})
)

export class LeftSide extends Component{
	render(){
		let { props } = this
		let editing = true
		let expsFilled = (exps) => {
			for(let i = 0; i<exps.length; i++){
			  if(!exps[i].amount || !exps[i].category) return false
		  }
		  return true
		}
		let party = props.transaction.paymentMethod != "QuickBooks"?true:
			(props.transaction.vendorID && props.vendors[props.transaction.vendorID]
			&& props.vendors[props.transaction.vendorID].address
			&& (props.vendors[props.transaction.vendorID].phoneNumber || props.vendors[props.transaction.vendorID].cellNumber)
			&& props.vendors[props.transaction.vendorID].accountNumber)?
			true:false
		return(
			<div
				className="wrapper"
				style={{
					 width: (props.colspan>1)?"50%":"100%"
   				   , overflowY: "hidden"
				   , overflowX: "hidden"
					 , paddingBottom:"10px"
					 , paddingRight:"5px"
				}}
			>
				<div style={{width: "100%", padding:"10px 30px 10px 20px", boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)", backgroundColor: "white"}}>
					<PaymentMethodSelect transactionID={props.transactionID} />
					<PropertyCombobox objectID={props.transactionID} />
				</div>
				<Lines objectID={props.transactionID} />
				<Divider style={{margin: "0"}}/>
				<div style={{width: "100%", padding:"0 30px 10px 20px", boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)", backgroundColor: "white"}}>
					<DueDatePicker objectID={props.transactionID} />
					<TransactionMemo objectID={props.transactionID} />
					<CheckBoxIsPaid objectID={props.transactionID} />
				</div>
			</div>
		)
	}
}

export default connect(select, dataActions)(LeftSide)



// WEBPACK FOOTER //
// ./src/routes/landlord/transactionForm/BillForm/LeftSide.js